import React, { useMemo } from 'react';
import buildClassName from 'js/utils/classNameBuilder.util';
import { getClassNames } from 'js/utils/classNames.util';
import { Control } from '../Control';
import { Checkbox } from '../Checkbox';
import { withField } from '../withField';

import style from './CheckboxGroup.scss';

export const CheckboxGroupBare = ({
    id,
    meta,
    options = [],
    label,
    hint,
    name,
    className = '',
    classNames: classNamesProps,
    onClick,
    children
}) => {
    const classNames = useMemo(
        () => {
            const { control, content } = classNamesProps || {};

            return {
                ...classNamesProps,
                control: getClassNames([control, style.groupControl]),
                content: getClassNames([content, style.groupContent])
            };
        }, [classNamesProps]
    );

    return (
        <Control {...{ id, meta, className, classNames, onClick, label, hint, animate: true }}>
            <ul className={buildClassName(['list'], style, classNames)}>
                {children != null
                    // Cloning isn't necessary as component should have all needed state from outside
                    // through withField or render props
                    ? React.Children.map(children, (component, index) => (
                        <li key={index} className={buildClassName(['item'], style, classNames)}>
                            {component}
                        </li>
                    ))
                    : options.map((item, index) =>
                        <li key={index} className={buildClassName(['item'], style, classNames)}>
                            <Checkbox {...item} name={name} />
                        </li>
                    )
                }
            </ul>
        </Control>
    );
};

export const CheckboxGroup = withField(CheckboxGroupBare);
